export default "__VITE_ASSET__019e84a6__"